<template>
  <div>
    <EditableArea
      v-if="content.menuNavigation"
      :class="[content.classeCssConteneur]"
      :content="content.menuNavigation"
      :parentTemplateId="metadata['mgnl:template']"
    >
    </EditableArea>
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';

export default {
  name: 'MenuNavigation',
  components: { EditableArea },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
};
</script>
